
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practical-typescript",
      function () {
        return require("private-next-pages/practical-typescript/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practical-typescript"])
      });
    }
  